module.exports = __webpack_public_path__ + "img/disable-edit-icon.7ece95b6.svg";